export enum IdentityTypeEnum {
    NSRU = 'NSRU',
    MOBILE = 'MOBILE',
    INTERNET_PRINCIPAL = 'INTERNET PRINCIPAL',
    INTERNET_SECONDAIRE = 'INTERNET SECONDAIRE',
    I_M = 'I+M',
    UNDEF = 'UNDEF',
    UNKNOWN = 'UNKNOWN',
}
